import { useEffect, useState } from "react";
import Get from "./Get";

export function useMarketAssets(params = {}) {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const tokenUnlocksOnly = Boolean(params.token_unlocks);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");

    Get.MarketAssets(tokenUnlocksOnly ? { token_unlocks: 1 } : undefined)
      .then((response) => {
        if (response?.success === false) throw new Error(response.message || "Market data is unavailable.");
        const rows = response?.data?.data ?? response?.data ?? response;
        if (!Array.isArray(rows)) throw new Error("The market API returned an invalid response.");
        if (active) setAssets(rows);
      })
      .catch((requestError) => {
        if (active) setError(requestError.message || "Market data could not be loaded.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [tokenUnlocksOnly]);

  return { assets, loading, error };
}

export const marketAsset = (market) => market?.base_asset ?? market?.baseAsset ?? market?.asset_data ?? {};

export const marketSymbol = (market) => String(market?.asset ?? marketAsset(market)?.symbol ?? "").toUpperCase();

export const marketName = (market) => marketAsset(market)?.name ?? market?.name ?? marketSymbol(market);

export const marketNetworks = (market) => {
  const asset = marketAsset(market);
  const networks = market?.networks ?? asset?.networks ?? (asset?.network ? [asset.network] : []);
  return Array.isArray(networks) ? networks : [];
};

export const marketNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const marketPrice = (ticker) => ticker?.price == null
  ? "—"
  : `$${ticker.price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: ticker.price < 1 ? 8 : 2 })}`;

export const marketChange = (ticker) => ticker?.change == null
  ? "—"
  : `${ticker.change > 0 ? "+" : ""}${ticker.change.toFixed(2)}%`;